module.exports = __webpack_public_path__ + "img/f97dab52a004f12923c83cb616c25eb1.svg";